import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { TEAM } from "../data/site";

export const About = () => {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="py-24 lg:py-36 bg-[#F0EFEA]"
        >
            <div className="max-w-[1500px] mx-auto px-6 md:px-12 lg:px-16">
                {/* Studio statement */}
                <div className="grid grid-cols-12 gap-6 lg:gap-12 mb-24">
                    <div className="col-span-12 lg:col-span-5">
                        <div className="overline text-[#4A4643] mb-6">
                            The studio
                        </div>
                        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-[#1A1A1A]">
                            A small studio<br />
                            with a <span className="italic text-[#8C7C6D]">long view</span>.
                        </h2>
                    </div>
                    <div className="col-span-12 lg:col-span-6 lg:col-start-7 space-y-6 text-[#4A4643] text-base lg:text-lg leading-relaxed font-light">
                        <p>
                            Design Desire LLP is an interior design studio founded on a
                            simple belief — good interiors are built by people who care
                            deeply about the lives lived inside them.
                        </p>
                        <p>
                            We work from two studios — a Pune head office and a Goa
                            atelier — across residential, commercial and turnkey
                            projects. Our practice is intentionally small so that every
                            project gets a principal&apos;s attention.
                        </p>
                        <p className="font-serif italic text-xl text-[#1A1A1A]">
                            &ldquo;We don&apos;t decorate rooms. We compose the way a day feels
                            inside them.&rdquo;
                        </p>
                    </div>
                </div>

                {/* Team */}
                <div className="mb-12 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
                    <div>
                        <div className="overline text-[#4A4643] mb-6">
                            The team
                        </div>
                        <h3 className="font-serif text-3xl md:text-4xl lg:text-5xl font-light tracking-tight text-[#1A1A1A]">
                            People behind the practice.
                        </h3>
                    </div>
                    <Link
                        to="/team"
                        data-testid="about-view-team"
                        className="btn-secondary self-start lg:self-end"
                    >
                        Meet the full team
                        <ArrowUpRight size={16} strokeWidth={1.5} />
                    </Link>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8 lg:gap-10">
                    {TEAM.slice(0, 5).map((m, i) => (
                        <motion.div
                            key={m.name}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.6, delay: i * 0.08 }}
                            data-testid={`team-member-${i}`}
                        >
                            <div className="img-zoom aspect-[3/4] w-full bg-[#E5E1D8] overflow-hidden">
                                <img
                                    src={m.image}
                                    alt={m.name}
                                    className="w-full h-full object-cover object-top"
                                    loading="lazy"
                                />
                            </div>
                            <h4 className="font-serif text-xl lg:text-2xl mt-5 text-[#1A1A1A] tracking-tight">
                                {m.name}
                            </h4>
                            <p className="overline text-[#8C7C6D] mt-2">{m.role}</p>
                            <p className="text-[14px] text-[#4A4643] mt-3 leading-relaxed font-light">
                                {m.bio}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
